import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import NotFound from './pages/NotFound';
import ReviewPage from './pages/ReviewPage';
import React, { useRef, useEffect } from 'react';

// Move usePageViews inside a component that is a child of <Router>
const PageViewTracker = () => {
  const location = useLocation();
  
  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'G-FZLGYB0BWC', {
        page_path: location.pathname,
      });
    }
  }, [location.pathname]);
  
  return null;
};

function App() {
  const homeRef = useRef();

  const handleHomeClick = () => {
    if (homeRef.current?.resetCategory) {
      homeRef.current.resetCategory();
    }
  };

  return (
    <Router>
      <PageViewTracker />
      <div className="min-h-screen flex flex-col">
        <Navbar onHomeClick={handleHomeClick} />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home ref={homeRef} />} />
            <Route path="/reviews/:title" element={<ReviewPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App; 